module.exports = __webpack_public_path__ + "img/about-2.52366916.png";